import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCategoryById } from "../../firebase/categories";
import { useAtom } from "jotai";
import { searchParamsAtom } from "../../store";

const CategoryCard = ({
  title = "Category",
  description = "Description goes here.",
  imageSrc,
  iconSrc,
  categoryId,
  cardClassName = "",
  buttonClassName = "",
  titleClassName = "",
  background = "",
  descriptionClassName = "",
}) => {
  const [category, setCategory] = useState(null)
  const [searchParams, setSearchParams] = useAtom(searchParamsAtom)
  const navigate = useNavigate()

  useEffect(() => {
    getCategoryById(categoryId).then((data) => {
      setCategory(data)
    })
  }, [categoryId])

  const handleClick = () => {
    let temp = [{ category: categoryId, subCategories: category.subCategories }]
    setSearchParams({ ...searchParams, categories: temp })
    navigate('/marketplace/categories')
  }

  return (
    <button
      className={`w-full h-full flex flex-col justify-between card-category relative group`}
      style={{ background: background }}
      onClick={handleClick}
    // to={`/marketplace/categories?categories=${categoryId}`}
    // to={`/marketplace/categories`}
    >
      <div
        className={`absolute top-0 right-0 bg-white p-2 lg:p-3 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition ${buttonClassName}`}
      >
        <img
          src={iconSrc || "/assets/icons/icon-arrow-up-right.svg"}
          alt="icon"
          className="max-w-[12px] max-h-[12px] lg:max-w-[unset] lg:max-h-[unset]"
        />
      </div>
      <div className="p-4 py-6 pb-0 lg:p-6  mb-0">
        <p
          className={`font-aero uppercase text-base lg:text-[32px] text-white leading-[1.2] ${titleClassName}`}
        >
          {title}
        </p>
        {/* <p
        className={`text-[8px] lg:text-base text-white ${descriptionClassName}`}
      >
        {description}
      </p> */}
      </div>

      <div className="relative pt-[100%] w-full">
        <img
          src={imageSrc || "/assets/decorations/category_default.png"}
          alt="category-image"
          className="absolute top-0 w-full h-full object-cover"
        />
      </div>
    </button>
  )
};

export default CategoryCard;
